import React, { useState, useEffect } from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const mapStyles = {        
  height: "15vh",
  width: "100%",
  position: 'relative',
  borderRadius: '10px', // Set border-radius here
  overflow: 'hidden',    // Ensures content stays within the rounded corners
  cursor: 'pointer'
};

const billingErrorStyles = {
  height: "15vh",
  width: "100%",
  position: 'relative',
  borderRadius: '10px',
  overflow: 'hidden',
  backgroundColor: '#f5f5f5',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid #ddd',
  cursor: 'pointer'
};

const GoogleMApp = () => {
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();
  const history = useHistory();
  const {t} = useTranslation();
  const [coordinates, setCoordinates] = useState({
    lat: appState.deliveryAddsInfo?.lat || 29.3759,
    lng: appState.deliveryAddsInfo?.lng || 47.9774
  });
  const [mapError, setMapError] = useState(false);

  // Get current location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCoordinates({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
          appDispatch({
            type: "setDeliveryAddsInfo",
            deliveryAddsInfo: {
              ...appState.deliveryAddsInfo,
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          });
        },
        (error) => {
          console.error("Error getting location: ", error);
          // You can handle location errors here (e.g., default to a certain location)
        }
      );
    }
  }, []);

  // Google Maps Static URL with dynamic coordinates
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyABahfPxb8GWRHM731v5QfZesxyEypXuGc";
  const staticMapImageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coordinates.lat},${coordinates.lng}&zoom=13&size=600x300&maptype=roadmap&markers=color:red%7Clabel:C%7C${coordinates.lat},${coordinates.lng}&key=${googleMapsApiKey}`;

  // Handle map image load error (billing issue)
  const handleMapError = () => {
    setShouldShowMap(false);
  };

  // Handle map image load success
  const handleMapLoad = () => {
    setShouldShowMap(true);
  };

  // Check if we should show the map based on billing status
  const [shouldShowMap, setShouldShowMap] = useState(false);

  // If billing issue, show alternative content
  if (!shouldShowMap) {
    return (
     <></>
    );
  }

  return (
    <div style={mapStyles} onClick={() => { history.push('/map') }} >
      <img 
        src={staticMapImageUrl} 
        alt={`Static map centered on coordinates (${coordinates.lat}, ${coordinates.lng})`} 
        style={{ height: "100%", width: "100%", objectFit: "cover" }}
        onError={handleMapError}
        onLoad={handleMapLoad}
      />
      
      {/* Sticky Marker */}
      <div style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '10',
        pointerEvents: 'none'
      }}>
        <LocationOnIcon style={{ fontSize: '50px', color: appState.storeInfo?.primaryColor }} />
      </div>
    </div>
  );
}

export default GoogleMApp;
